import React from "react";
import classNames from "classnames";

import * as cns from "./Loader.module.css";

type ILoaderSize = "xsm" | "sm" | "md" | "lg" | "xl";

export type ILoaderProps = {
    className?: string;
    scaleToContainer?: boolean;
    fullWidth?: boolean;
    padding?: IPaddingSize;
} & (IStandardSizeScenario | ICustomSizeScenario);

type IStandardSizeScenario = {
    size?: ILoaderSize;
    customSize?: never;
};

type ICustomSizeScenario = {
    customSize?: string;
    size?: never;
};

const loaderIconSizeCn: Record<ILoaderSize, string> = {
    xsm: cns.loaderIconWrapXSm,
    sm: cns.loaderIconWrapSm,
    md: cns.loaderIconWrapMd,
    lg: cns.loaderIconWrapLg,
    xl: cns.loaderIconWrapXl
};

type IPaddingSize = "sm" | "md" | "lg" | "xl" | "xxl";
const loaderWrapPaddingCn: Record<IPaddingSize, string> = {
    sm: cns.loaderPaddingSm,
    md: cns.loaderPaddingMd,
    lg: cns.loaderPaddingLg,
    xl: cns.loaderPaddingXLg,
    xxl: cns.loaderPaddingXXL
};

//  Component
export function Loader(props: ILoaderProps) {
    const {size = "sm", padding = "sm", scaleToContainer, fullWidth, className, customSize} = props;

    const loaderWrapCn = classNames(
        className,
        cns.loader,
        loaderWrapPaddingCn[padding],
        scaleToContainer && cns.loaderScaleToContainer,
        fullWidth && cns.loaderFullWidth
    );

    const iconSizeCn = customSize ? customSize : classNames(loaderIconSizeCn[size]);
    const iconWrapCn = classNames(cns.loaderIconWrap, scaleToContainer ? cns.loaderScaleToContainer : iconSizeCn);

    return (
        <div className={loaderWrapCn}>
            <div className={iconWrapCn}>
                <svg
                    id="edPkcKovG7S1"
                    className={cns.loaderGroup}
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 64 64"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    width="64"
                    height="64"
                >
                    <g id="edPkcKovG7S2" transform="matrix(1.007494 0 0 1.007494-.239807-.239808)">
                        <g className={cns.loaderLowerChevron}>
                            <path
                                id="edPkcKovG7S4"
                                d="M43.978,38.432l84.954994.569848L129.575,124.029l21.399-21.399-.000031-85.596971L65.378,17.033l-21.4,21.399Z"
                                transform="matrix(.381353 0 0 0.381353-1.078717 1.008749)"
                                fill="#070707"
                                fillRule="evenodd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <g className={cns.loaderUpperChevron}>
                            <path
                                id="edPkcKovG7S5"
                                d="M43.978,38.432l-21.399,21.4v85.596h85.597l21.399-21.399h-85.597v-85.597Z"
                                transform="matrix(.381353 0 0 0.381353-1.106233 1.036263)"
                                fill="#070707"
                                fillRule="evenodd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    );
}
